export const YusaAssociationListSelector = ({
  yusaAssociationData: { YusaAssociationList }
}) => YusaAssociationList;

export const YusaYearListSelector = ({ YusaYearList: { YusaYearList } }) =>
  YusaYearList;
